import { graphql } from '@apollo/client/react/hoc';
import { getUrlId } from './useFormQuery';
import { DocumentNode } from 'graphql';

const skipCheck = (
  props: any,
  {
    defaultRecord,
    idParam,
    idParamValueFn,
  }: { defaultRecord: boolean; idParam: string; idParamValueFn?: (_: any) => string }
): boolean => {
  if (!props?.match?.params) return true;

  const urlId = getUrlId(props, { idParam: idParam, idParamValueFn: idParamValueFn, params: props.match.params });

  return ((defaultRecord && urlId !== 'New') || (!defaultRecord && urlId === 'New')) && idParam !== 'uuid';
};

const formQuery = (
  query: DocumentNode,
  defaultRecord: boolean = false,
  duplicate: boolean = false,
  idParam: string = 'id',
  idParamValueFn?: (_: any) => string,
  fallback: boolean = true,
  additionalVariables?: (_: any) => {}
) => {
  return graphql(query, {
    options(props: any) {
      let urlId;
      if (duplicate) {
        if (history.state?.state?.duplicateId) {
          urlId = history.state.state.duplicateId;
        }
      } else {
        urlId = getUrlId(props, { idParam, idParamValueFn, fallback, params: props.match.params });
      }

      return {
        variables: {
          [idParam]: urlId === 'New' ? null : urlId,
          ...additionalVariables?.(props),
        },
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
      };
    },
    name: 'formData',
    skip: (props) =>
      skipCheck(props, {
        defaultRecord: defaultRecord,
        idParam: idParam,
        idParamValueFn: idParamValueFn,
      }),
  });
};

export default formQuery;
